import type { Persona } from "types/Persona";
import { isSubagentEnabled } from "components/ThemeSelector/useSubagentState";
import styles from "./PersonaSelector.module.scss";

type Props = {
  persona: Persona;
};

export function PersonaListItem({ persona }: Props) {
  const {
    name,
    isImageGenerator = false,
    maturity = "stable",
    subagentCapable = false,
    author,
    lastUpdate,
    description,
  } = persona;

  return (
    <>
      {name}
      {maturity === "preview" && (
        <span className={styles.pillWarning}>Preview</span>
      )}
      {isImageGenerator && (
        <span className={styles.pillSuccess}>Image Generation</span>
      )}
      {subagentCapable && isSubagentEnabled() && (
        <span className={styles.pillInfo}>Subagents</span>
      )}
      {(author || lastUpdate || description) && (
        <p className={styles.personaDetails}>
          {author && (
            <span>
              Author:
              <span className={styles.metadata}>{author}</span>
            </span>
          )}
          {author && lastUpdate && " | "}
          {lastUpdate && (
            <span>
              Last Updated:
              <span className={styles.metadata}>{lastUpdate}</span>
            </span>
          )}
          <span className={styles.description}>
            {description && description}
          </span>
        </p>
      )}
    </>
  );
}
